import React from "react";
import { motion } from "framer-motion";

function Footer() {
  return (
    <footer className="bg-gradient-to-r from-yellow-300 to-pink-400 text-white text-center px-4 py-6 mt-10 shadow-inner">
      <motion.p
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 300 }}
        className="text-sm sm:text-base font-semibold"
      >
        🌟 © {new Date().getFullYear()} Arabic learning hub — Made with ❤️ by Saad Charif Tribak
      </motion.p>
      <div className="mt-2 text-xs">
        <a href="/privacy" className="underline hover:text-white">Privacy Policy</a>
        <span className="mx-2">•</span>
        <a href="/deleteaccount" className="underline hover:text-white">Delete Account</a>
      </div>
    </footer>
  );
}

export default Footer;
